import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';

import { Flex } from '../atom/Layout';
import Icon from '../atom/Icon';
import { Text } from '../atom/Text';

import ThemeStyle from '../../../lib/style/ThemeStyle';

export const ArrowToggleLogin = ({
  title = '',
  children,
  style,
}) => {
    const [isToggleOn, setIsToggleOn] = useState(false);

    return (
      <Flex column style={style}>
        <Flex
          width="100%"
          onClick={() => setIsToggleOn(!isToggleOn)}
        >
          <Text size="12" style={{ color: "#555555" }}>{title}</Text>
          <Icon iconName={!isToggleOn ? 'expand_more' : 'expand_less'} />
        </Flex>
        {isToggleOn && (
          <Flex
            column
            padding="1.25rem 0 0"
            alignItems="flex-start"
            width="100%"
          >
            {children}
          </Flex>
        )}
      </Flex>
    );
};

export const ArrowToggleChildren = ({
  title = '',
  children,
  hasBorderRadius = false,
}) => {
  const [isToggleOn, setIsToggleOn] = useState(false);

  return (
    <Flex
      column
      style={{
        border: hasBorderRadius && `solid 1px ${ThemeStyle.color.pinkishGrey}`,
        borderRadius: hasBorderRadius && '6px',
      }}
    >
      <Flex
        justifyContent="space-between"
        padding={hasBorderRadius ? '1rem 0' : '1.25rem 0'}
        width="100%"
        style={{
          borderBottom:
            !hasBorderRadius && `1px solid ${ThemeStyle.background.grey}`,
          backgroundColor: hasBorderRadius && ThemeStyle.background.grey,
        }}
        onClick={() => setIsToggleOn(!isToggleOn)}
      >
        <Text>{title}</Text>
        <Icon iconName={!isToggleOn ? 'expand_more' : 'expand_less'} />
      </Flex>
      {isToggleOn && (
        <Flex
          column
          padding="1.25rem 0 0"
          alignItems="flex-start"
          width="100%"
          style={{
            borderTop: `1px solid ${ThemeStyle.background.grey}`,
            borderBottom: !hasBorderRadius && '1px solid rgb(246, 246, 246)',
            background: ThemeStyle.background.white,
          }}
        >
          {children}
        </Flex>
      )}
    </Flex>
  );
};
export const ArrowToggle = ({
  content = [{ id: '', title: '', description: [''] }],
  hasBorderRadius = false,
  titleBackground = 'transparent',
  descriptionBackground = ThemeStyle.background.white,
  toggleOnIdx = null,
}) => {
  const [isToggleOn, setIsToggleOn] = useState(
    Array(content.length).fill(false),
  );

  useEffect(() => {
    toggleOnIdx !== null && setIsToggleOn({ ...isToggleOn, [toggleOnIdx]: true })
  }, [content]);

  return content.map((data, idx) => (
    <Flex
      column
      key={idx}
      style={{
        border: hasBorderRadius && `solid 1px ${ThemeStyle.color.pinkishGrey}`,
        borderRadius: hasBorderRadius && '6px',
      }}
    >
      <Flex
        justifyContent="space-between"
        padding={hasBorderRadius ? '1rem' : '1.25rem'}
        width="100%"
        style={{
          borderBottom:
            !hasBorderRadius && `1px solid ${ThemeStyle.background.grey}`,
          backgroundColor: hasBorderRadius && ThemeStyle.background.grey,
          background: titleBackground,
        }}
        onClick={() =>
          setIsToggleOn({ ...isToggleOn, [idx]: !isToggleOn[idx] })
        }
      >
        <Text>{data.title}</Text>
        <Icon iconName={!isToggleOn[idx] ? 'expand_more' : 'expand_less'} />
      </Flex>
      {isToggleOn[idx] && (
        <Flex
          column
          padding="0.625rem 1.25rem"
          alignItems="flex-start"
          width="100%"
          style={{
            borderTop: `1px solid ${ThemeStyle.background.grey}`,
            borderBottom: !hasBorderRadius && '1px solid rgb(246, 246, 246)',
            background: descriptionBackground,
          }}
        >
          {data.description.map((text, idx) => (
            <Text
              key={idx}
              size={12}
              lineHeight={1.5}
              style={{ display: 'block' }}
            >
              {parse(text)}
            </Text>
          ))}
        </Flex>
      )}
    </Flex>
  ));
};

export const QnAToggle = ({ content = [{ question: '', answer: '' }] }) => {
  const [isToggleOn, setIsToggleOn] = useState(
    Array(content.length).fill(false),
  );

  return content.map((item, idx) =>
    ['Q', 'A'].map((icon, qnaIdx) => (
      <Flex
        padding={`${icon === 'Q' ? '1.25rem' : '0.625rem'} 1.25rem`}
        key={qnaIdx}
        alignItems="flex-start"
        justifyContent="flex-start"
        width="100%"
        style={{
          borderBottom: `1px solid ${ThemeStyle.background.grey}`,
          display: icon === 'A' && !isToggleOn[idx] ? 'none' : 'flex',
        }}
        onClick={() =>
          icon === 'Q'
            ? setIsToggleOn({ ...isToggleOn, [idx]: !isToggleOn[idx] })
            : undefined
        }
      >
        <Text
          color="background"
          textAlign="center"
          style={{
            background:
              ThemeStyle.color[icon === 'Q' ? 'pinkishGrey' : 'orangePink'],
            borderRadius: '50%',
            width: '1.25rem',
            height: '1.25rem',
          }}
        >
          {icon}
        </Text>
        <Flex
          justifyContent="space-between"
          width="100%"
          style={{
            marginLeft: '0.625rem',
          }}
        >
          <Text size={icon === 'Q' ? 16 : 12} lineHeight={1.5}>
            {parse(item[icon === 'Q' ? 'question' : 'answer'])}
          </Text>
        </Flex>
      </Flex>
    )),
  );
};
